import { render, staticRenderFns } from "./Spreadsheet.vue?vue&type=template&id=bf745b8a&"
import script from "./Spreadsheet.vue?vue&type=script&lang=js&"
export * from "./Spreadsheet.vue?vue&type=script&lang=js&"
import style0 from "./Spreadsheet.vue?vue&type=style&index=0&id=bf745b8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports